import "./PreOnboarding.css";
import Loginheader from "../../../components/loginheader/Loginheader";
import { useContext, useState } from "react";
import { FaUser, FaUniversity, FaMapMarkerAlt, FaGraduationCap, FaFileAlt } from "react-icons/fa";
import Icon from "../../../assests/sidebar-icon.png";
import { AuthContext } from "../../../context/AuthContext";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, Form, Input, DatePicker, Button, Row, Col, Typography, Space } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs"; // Import dayjs
import customParseFormat from "dayjs/plugin/customParseFormat"; // Plugin for custom date parsing

dayjs.extend(customParseFormat); // Enable custom date parsing

const { Title } = Typography;

export default function PreOnboardingForm() {
  const [preOnboardData, setPreOnboardData] = useState({});
  const [fileData, setFileData] = useState({});
  const [showSideBar, setShowSideBar] = useState(false);
  const [activeSection, setActiveSection] = useState("personal");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { backUrl } = useContext(AuthContext);
  const [isExperienced, setIsExperienced] = useState(false);
  const { cid } = useParams();


  const [addEducation, setAddEducation] = useState(1);
  const [addCareer, setAddCareer] = useState(1);
  const [addReference, setAddReference] = useState(1);
  const [addActivity, setAddActivity] = useState(1);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFileData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else {
      setPreOnboardData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleToggle = async () => {
    setIsExperienced(!isExperienced)
  }

  const handleEducationChange = (index, field, value) => {
    setPreOnboardData((prev) => {
      const updatedData = { ...prev };
      if (!updatedData.education_history) {
        updatedData.education_history = [];
      }
      if (!updatedData.education_history[index]) {
        updatedData.education_history[index] = {};
      }
      updatedData.education_history[index][field] = value;
      return updatedData;
    });
  };

  const handleCareerChange = (index, field, value) => {
    setPreOnboardData((prev) => {
      const updatedData = { ...prev };
      if (!updatedData.career_history) {
        updatedData.career_history = [];
      }
      if (!updatedData.career_history[index]) {
        updatedData.career_history[index] = {};
      }
      updatedData.career_history[index][field] = value;
      return updatedData;
    });
  };

  const handleReferenceChange = (index, field, value) => {
    setPreOnboardData((prev) => {
      const updatedData = { ...prev };
      if (!updatedData.reference_history) {
        updatedData.reference_history = [];
      }
      if (!updatedData.reference_history[index]) {
        updatedData.reference_history[index] = {};
      }
      updatedData.reference_history[index][field] = value;
      return updatedData;
    });
  };

  const handleActivityChange = (index, field, value) => {
    setPreOnboardData((prev) => {
      const updatedData = { ...prev };
      if (!updatedData.extra_curricular_activity) {
        updatedData.extra_curricular_activity = [];
      }
      if (!updatedData.extra_curricular_activity[index]) {
        updatedData.extra_curricular_activity[index] = {};
      }
      updatedData.extra_curricular_activity[index][field] = value;
      return updatedData;
    });
  };

  const handleChildChange = (index, field, value) => {
    setPreOnboardData((prev) => {
      const updatedData = { ...prev };
      if (!updatedData.child_details) {
        updatedData.child_details = [];
      }
      if (!updatedData.child_details[index]) {
        updatedData.child_details[index] = {};
      }
      updatedData.child_details[index][field] = value;
      return updatedData;
    });
  };

  const validateForm = () => {
    const requiredFields = [
      "salutation",
      "first_name",
      "mobile_number",
      "email_id",
      "aadhaar_card_number",
      "pan_card_number",
      "date_of_birth",
      "place_of_birth",
      "mother_tongue",
      "gender",
      "blood_group",
      "emergency_contact_person",
      "emergency_contact_number",
      "bank_account_number",
      "ifsc_code",
      "esic",
      "branch_name",
      "address_for_communication",
      "area",
      "city",
      "state",
      "country",
      "pincode",
      "height",
      "weight",
      "religion",
      "permanent_address_for_communication",
      "permanent_area",
      "permanent_city",
      "permanent_state",
      "permanent_country",
      "permanent_pincode",
    ];

    const newErrors = {};
    requiredFields.forEach((field) => {
      if (!preOnboardData[field] || preOnboardData[field].toString().trim() === "") {
        newErrors[field] = "This field is required";
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const missingFields = Object.keys(newErrors)
        .map((f) => f.replace(/_/g, " "))
        .join(", ");
      alert(`Please fill the following required fields:\n\n${missingFields}`);
    }

    return Object.keys(newErrors).length === 0;
  };

  const submitFormData = async () => {
    if (!validateForm()) {
      alert("Validation failed");
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      Object.keys(preOnboardData).forEach((key) => {
        const value = preOnboardData[key];
        if (value !== null && value !== undefined && value !== "") {
          if (Array.isArray(value) || typeof value === "object") {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        }
      });

      Object.keys(fileData).forEach((key) => {
        if (fileData[key]) {
          formData.append(key, fileData[key]);
        }
      });

      console.log("Submitting to:", `${backUrl}/api/emp/candidate-preonboarding-form/${cid}/`);
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const res = await axios.put(
        `${backUrl}/api/emp/candidate-preonboarding-form/${cid}/`,
        formData
      );

      toast.success(res.data.message || "Form submitted successfully!");
      setTimeout(() => {
        window.close();
      }, 3000);
    } catch (error) {
      const errMsg =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.response?.data?.data ||
        "Error submitting form. Please try again.";

      console.error("Error submitting form:", errMsg);
      toast.error(errMsg, {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSectionSelect = (section) => {
    setActiveSection(section);
    setShowSideBar(false);
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <Loginheader />
      <a className="mb-2 ms-3 bg-light" onClick={() => setShowSideBar(!showSideBar)}>
        <img
          id="show-icon1"
          className={showSideBar ? "rotate mb-2 ms-3" : "mb-2 ms-3"}
          src={Icon}
          alt="Toggle Sidebar"
        />
      </a>
      {showSideBar && (
        <div id="sidebar-view" className={showSideBar ? "active" : ""}>
          <div className="sidebar-content">
            <ul>
              <li onClick={() => handleSectionSelect("personal")}>Personal Details</li>
              <li onClick={() => handleSectionSelect("bank")}>Bank Details</li>
              <li onClick={() => handleSectionSelect("address")}>Address Details</li>
              <li onClick={() => handleSectionSelect("education")}>Education Details</li>
              <li onClick={() => handleSectionSelect("documents")}>Documents</li>
            </ul>
          </div>
        </div>
      )}

      <div id="show-container1" className="container mt-4 mb-4">
        <div className="row justify-content-center">
          {[
            { key: "personal", label: "Personal Details", icon: <FaUser /> },
            { key: "bank", label: "Bank Details", icon: <FaUniversity /> },
            { key: "address", label: "Address Details", icon: <FaMapMarkerAlt /> },
            { key: "education", label: "Education Details", icon: <FaGraduationCap /> },
            { key: "documents", label: "Documents", icon: <FaFileAlt /> },
          ].map((item) => (
            <div className="col text-center position-relative" key={item.key}>
              <div
                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: activeSection === item.key ? "#0d6efd" : "#e9ecef",
                  color: activeSection === item.key ? "#fff" : "#6c757d",
                  zIndex: 1,
                  cursor: "pointer",
                }}
                onClick={() => setActiveSection(item.key)}
              >
                {item.icon}
              </div>
              <small
                className={activeSection === item.key ? "text-primary fw-bold" : "text-muted"}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveSection(item.key)}
              >
                {item.label}
              </small>
            </div>
          ))}
        </div>

        <br />
        <center>
          <button style={{ color: 'white', padding: '2px 10px 2px 10px' }} onClick={handleToggle}>
            {
              isExperienced ? "Experienced" : "Fresher"
            }
          </button>
        </center>
        <hr />
      </div>

      <center>
        <p style={{ color: "#d32f2f", marginBottom: "16px" }}>* Indicates required fields</p>
      </center>

      <div className="section-content">
        {activeSection === "personal" && (
          <>
            <center>
              <h2 className="mb-5">Personal Details</h2>
            </center>
            <div className="container px-4">
              <div className="row gy-4">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label>
                      Salutation <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <select
                      name="salutation"
                      value={preOnboardData.salutation || ""}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Salutation</option>
                      <option value="Mr">Mr</option>
                      <option value="Ms">Ms</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Dr">Dr</option>
                    </select>
                    {errors.salutation && (
                      <p style={{ color: "red", fontSize: "12px" }}>{errors.salutation}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Initial
                    </label>
                    <input
                      type="text"
                      name="initial"
                      value={preOnboardData.initial || ""}
                      onChange={handleChange}
                      placeholder="initial"
                      required
                    />
                    {errors.initial && <p style={{ color: "red", fontSize: "12px" }}>{errors.initial}</p>}
                  </div>

                  <div className="form-group">
                    <label>
                      Surname
                    </label>
                    <input
                      type="text"
                      name="surname"
                      value={preOnboardData.surname || ""}
                      onChange={handleChange}
                      placeholder="surname"
                      required
                    />
                    {errors.surname && <p style={{ color: "red", fontSize: "12px" }}>{errors.surname}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      First Name <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      value={preOnboardData.first_name || ""}
                      onChange={handleChange}
                      placeholder="Name"
                      required
                    />
                    {errors.first_name && <p style={{ color: "red", fontSize: "12px" }}>{errors.first_name}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="last_name"
                      value={preOnboardData.last_name || ""}
                      onChange={handleChange}
                      placeholder="Name"
                      required
                    />
                    {errors.last_name && <p style={{ color: "red", fontSize: "12px" }}>{errors.last_name}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Mobile Number <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="mobile_number"
                      value={preOnboardData.mobile_number || ""}
                      onChange={handleChange}
                      placeholder="Mobile Number"
                      required
                    />
                    {errors.mobile_number && <p style={{ color: "red", fontSize: "12px" }}>{errors.mobile_number}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Email Id <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="email"
                      name="email_id"
                      value={preOnboardData.email_id || ""}
                      onChange={handleChange}
                      placeholder="Email Id"
                      required
                    />
                    {errors.email_id && <p style={{ color: "red", fontSize: "12px" }}>{errors.email_id}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Aadhaar No <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="number"
                      name="aadhaar_card_number"
                      value={preOnboardData.aadhaar_card_number || ""}
                      onChange={handleChange}
                      placeholder="aadhaar card number"
                      required
                    />
                    {errors.aadhaar_card_number && <p style={{ color: "red", fontSize: "12px" }}>{errors.aadhaar_card_number}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      PAN No <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="pan_card_number"
                      value={preOnboardData.pan_card_number || ""}
                      onChange={handleChange}
                      placeholder="pan_card_number number"
                      required
                    />
                    {errors.pan_card_number && <p style={{ color: "red", fontSize: "12px" }}>{errors.pan_card_number}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Date Of Birth <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="date"
                      name="date_of_birth"
                      value={preOnboardData.date_of_birth || ""}
                      onChange={handleChange}
                      required
                    />
                    {errors.date_of_birth && <p style={{ color: "red", fontSize: "12px" }}>{errors.date_of_birth}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Place Of Birth <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="place_of_birth"
                      value={preOnboardData.place_of_birth || ""}
                      onChange={handleChange}
                      placeholder="Place of birth"
                      required
                    />
                    {errors.place_of_birth && <p style={{ color: "red", fontSize: "12px" }}>{errors.place_of_birth}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Mother Tongue <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="mother_tongue"
                      value={preOnboardData.mother_tongue || ""}
                      onChange={handleChange}
                      placeholder="Mother Tongue"
                      required
                    />
                    {errors.mother_tongue && <p style={{ color: "red", fontSize: "12px" }}>{errors.mother_tongue}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Gender <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <select
                      name="gender"
                      value={preOnboardData.gender || ""}
                      onChange={handleChange}
                      required
                      style={{ width: "100%", padding: "8px" }}
                    >
                      <option value="">-- Select Gender --</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    {errors.gender && <p style={{ color: "red", fontSize: "12px" }}>{errors.gender}</p>}
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label>
                      Religion <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="religion"
                      value={preOnboardData.religion || ""}
                      onChange={handleChange}
                      placeholder="Religion"
                      required
                    />
                    {errors.religion && <p style={{ color: "red", fontSize: "12px" }}>{errors.religion}</p>}
                  </div>

                  <div className="form-group">
                    <label>
                      Caste <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="caste"
                      value={preOnboardData.caste || ""}
                      onChange={handleChange}
                      placeholder="Caste"
                      required
                    />
                    {errors.caste && <p style={{ color: "red", fontSize: "12px" }}>{errors.caste}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Blood Group <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="blood_group"
                      value={preOnboardData.blood_group || ""}
                      onChange={handleChange}
                      placeholder="Blood group"
                      required
                    />
                    {errors.blood_group && <p style={{ color: "red", fontSize: "12px" }}>{errors.blood_group}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Height <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="height"
                      value={preOnboardData.height || ""}
                      onChange={handleChange}
                      placeholder="Height"
                      required
                    />
                    {errors.height && <p style={{ color: "red", fontSize: "12px" }}>{errors.height}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Weight <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="weight"
                      value={preOnboardData.weight || ""}
                      onChange={handleChange}
                      placeholder="Weight"
                      required
                    />
                    {errors.weight && <p style={{ color: "red", fontSize: "12px" }}>{errors.weight}</p>}
                  </div>
                  <div className="form-group">
                    <label>Marital Status</label>
                    <select
                      name="marital_status"
                      value={preOnboardData.marital_status || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Option</option>
                      <option value="Married">Married</option>
                      <option value="Unmarried">Unmarried</option>
                      <option value="Single Parent">Single Parent</option>
                      <option value="Separated">Separated</option>
                      <option value="Divorced">Divorced</option>
                    </select>
                  </div>
                  {preOnboardData.marital_status === "Married" && (
                    <>
                      <div className="form-group">
                        <label>Wedding Date</label>
                        <input
                          type="date"
                          name="wedding_date"
                          value={preOnboardData.wedding_date || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label>Spouse Name</label>
                        <input
                          type="text"
                          name="spouse_name"
                          value={preOnboardData.spouse_name || ""}
                          onChange={handleChange}
                          placeholder="Spouse Name"
                        />
                      </div>
                      <div className="form-group">
                        <label>Spouse DOB</label>
                        <input
                          type="date"
                          name="spouse_dob"
                          value={preOnboardData.spouse_dob || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <Typography.Title level={5}>Children Details</Typography.Title>
                          <Button
                            type="dashed"
                            icon={<PlusOutlined />}
                            onClick={() => {
                              const updated = [
                                ...(preOnboardData.child_details || []),
                                { child_name: "", child_dob: "", child_gender: "" },
                              ];
                              handleChange({
                                target: { name: "child_details", value: updated },
                              });
                            }}
                          >
                            Add Child
                          </Button>
                        </div>
                        {(preOnboardData.child_details || []).map((child, index) => (
                          <Card key={index} className="mb-3">
                            <Space align="start" style={{ display: "flex", justifyContent: "space-between" }}>
                              <Form layout="vertical" style={{ flex: 1 }}>
                                <Form.Item label="Child Name">
                                  <Input
                                    value={child.child_name}
                                    onChange={(e) => {
                                      const updated = [...preOnboardData.child_details];
                                      updated[index].child_name = e.target.value;
                                      handleChange({
                                        target: { name: "child_details", value: updated },
                                      });
                                    }}
                                    placeholder="Enter child name"
                                  />
                                </Form.Item>
                                <Form.Item label="Child Gender">
                                  <Input
                                    value={child.child_gender}
                                    onChange={(e) => {
                                      const updated = [...preOnboardData.child_details];
                                      updated[index].child_gender = e.target.value;
                                      handleChange({
                                        target: { name: "child_details", value: updated },
                                      });
                                    }}
                                    placeholder="Enter child gender"
                                  />
                                </Form.Item>
                                <Form.Item label="Child DOB">
                                  <DatePicker
                                    style={{ width: "100%" }}
                                    value={child.child_dob ? dayjs(child.child_dob) : null}
                                    onChange={(date, dateString) => {
                                      const updated = [...preOnboardData.child_details];
                                      updated[index].child_dob = dateString;
                                      handleChange({
                                        target: { name: "child_details", value: updated },
                                      });
                                    }}
                                  />
                                </Form.Item>
                              </Form>
                              <Button
                                danger
                                icon={<CloseOutlined />}
                                onClick={() => {
                                  const updated = preOnboardData.child_details.filter((_, i) => i !== index);
                                  handleChange({
                                    target: { name: "child_details", value: updated },
                                  });
                                }}
                              />
                            </Space>
                          </Card>
                        ))}
                      </div>
                    </>
                  )}

                  <div style={{ marginTop: "20px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Typography.Title level={5}> Details</Typography.Title>
                      <Button
                        type="dashed"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          const updated = [
                            ...(preOnboardData.siblings_details || []),
                            { sibling_name: "", sibling_gender: "", sibling_profession: "" },
                          ];
                          handleChange({
                            target: { name: "siblings_details", value: updated },
                          });
                        }}
                      >
                        Add Sibling
                      </Button>
                    </div>
                    {(preOnboardData.siblings_details || []).map((sibling, index) => (
                      <Card key={index} className="mb-3">
                        <Space align="start" style={{ display: "flex", justifyContent: "space-between" }}>
                          <Form layout="vertical" style={{ flex: 1 }}>
                            <Form.Item label="Sibling Name">
                              <Input
                                value={sibling.sibling_name}
                                onChange={(e) => {
                                  const updated = [...preOnboardData.siblings_details];
                                  updated[index].sibling_name = e.target.value;
                                  handleChange({
                                    target: { name: "siblings_details", value: updated },
                                  });
                                }}
                                placeholder="Enter sibling name"
                              />
                            </Form.Item>
                            <Form.Item label="Sibling Gender">
                              <Input
                                value={sibling.sibling_gender}
                                onChange={(e) => {
                                  const updated = [...preOnboardData.siblings_details];
                                  updated[index].sibling_gender = e.target.value;
                                  handleChange({
                                    target: { name: "sibling_details", value: updated },
                                  });
                                }}
                                placeholder="Enter Sibling gender"
                              />
                            </Form.Item>
                            <Form.Item label="Sibling DOB">
                              <DatePicker
                                style={{ width: "100%" }}
                                value={sibling.sibling_dob ? dayjs(sibling.sibling_dob) : null}
                                onChange={(date, dateString) => {
                                  const updated = [...preOnboardData.siblings_details];
                                  updated[index].sibling_dob = dateString;
                                  handleChange({
                                    target: { name: "siblings_details", value: updated },
                                  });
                                }}
                              />
                            </Form.Item>
                            <Form.Item label="Sibling Profession">
                              <Input
                                value={sibling.sibling_Profession}
                                onChange={(e) => {
                                  const updated = [...preOnboardData.siblings_details];
                                  updated[index].sibling_Profession = e.target.value;
                                  handleChange({
                                    target: { name: "sibling_details", value: updated },
                                  });
                                }}
                                placeholder="Enter Sibling Profession"
                              />
                            </Form.Item>
                          </Form>
                          <Button
                            danger
                            icon={<CloseOutlined />}
                            onClick={() => {
                              const updated = preOnboardData.siblings_details.filter((_, i) => i !== index);
                              handleChange({
                                target: { name: "siblings_details", value: updated },
                              });
                            }}
                          />
                        </Space>
                      </Card>
                    ))}
                  </div>

                  <div className="form-group">
                    <label>
                      Emergency Contact Person <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="emergency_contact_person"
                      value={preOnboardData.emergency_contact_person || ""}
                      onChange={handleChange}
                      placeholder="Contact Person"
                      required
                    />
                    {errors.emergency_contact_person && (
                      <p style={{ color: "red", fontSize: "12px" }}>{errors.emergency_contact_person}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Emergency Contact Number <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="emergency_contact_number"
                      value={preOnboardData.emergency_contact_number || ""}
                      onChange={handleChange}
                      placeholder="Contact Number"
                      required
                    />
                    {errors.emergency_contact_number && (
                      <p style={{ color: "red", fontSize: "12px" }}>{errors.emergency_contact_number}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      ESIC Number <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="esic"
                      value={preOnboardData.esic || ""}
                      onChange={handleChange}
                      placeholder="ESI no"
                      maxLength={17}
                      required
                    />
                    {errors.esic && <p style={{ color: "red", fontSize: "12px" }}>{errors.esic}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      UAN Number <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="uan_number"
                      value={preOnboardData.uan_number || ""}
                      onChange={handleChange}
                      placeholder="UAN no"
                      required
                    />
                    {errors.uan_number && <p style={{ color: "red", fontSize: "12px" }}>{errors.uan_number}</p>}
                  </div>
                  <div className="form-group">
                    <label>Father's Name</label>
                    <input
                      type="text"
                      name="father_name"
                      value={preOnboardData.father_name || ""}
                      onChange={handleChange}
                      placeholder="Father Name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Father's Profession</label>
                    <input
                      type="text"
                      name="father_profession"
                      value={preOnboardData.father_profession || ""}
                      onChange={handleChange}
                      placeholder="Father Profession"
                    />
                  </div>
                  <div className="form-group">
                    <label>Mother's Name</label>
                    <input
                      type="text"
                      name="mother_name"
                      value={preOnboardData.mother_name || ""}
                      onChange={handleChange}
                      placeholder="Mother Name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Mother's Profession</label>
                    <input
                      type="text"
                      name="mother_profession"
                      value={preOnboardData.mother_profession || ""}
                      onChange={handleChange}
                      placeholder="Mother Profession"
                    />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <button className="text-light p-2 py-1" onClick={() => setActiveSection("bank")}>
                Next
              </button>
            </center>
          </>
        )}

        {activeSection === "bank" && (
          <>
            <center>
              <h2 className="mb-5">Bank Details</h2>
            </center>
            <center>
              <div id="bank-area" className="container row px-4">
                <div className="col-12 col-md-6 p-2">
                  <div className="form-group">
                    <label>
                      Bank Account Number <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="bank_account_number"
                      value={preOnboardData.bank_account_number || ""}
                      onChange={handleChange}
                      placeholder="Bank Account No"
                      required
                    />
                    {errors.bank_account_number && (
                      <p style={{ color: "red", fontSize: "12px" }}>{errors.bank_account_number}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      IFSC Code <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="ifsc_code"
                      value={preOnboardData.ifsc_code || ""}
                      onChange={handleChange}
                      placeholder="IFSC Code"
                      required
                    />
                    {errors.ifsc_code && <p style={{ color: "red", fontSize: "12px" }}>{errors.ifsc_code}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Bank Name <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="back_name"
                      value={preOnboardData.back_name || ""}
                      onChange={handleChange}
                      placeholder="Bank Name"
                      required
                    />
                    {errors.back_name && <p style={{ color: "red", fontSize: "12px" }}>{errors.back_name}</p>}
                  </div>
                </div>
                <div className="col-12 col-md-6 p-2">

                  <div className="form-group">
                    <label>
                      Branch Name <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="branch_name"
                      value={preOnboardData.branch_name || ""}
                      onChange={handleChange}
                      placeholder="Branch Name"
                      required
                    />
                    {errors.branch_name && <p style={{ color: "red", fontSize: "12px" }}>{errors.branch_name}</p>}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                <button className="text-light p-2 py-1" onClick={() => setActiveSection("personal")}>
                  Previous
                </button>
                <button className="text-light p-2 py-1" onClick={() => setActiveSection("address")}>
                  Next
                </button>
              </div>
            </center>
          </>
        )}

        {activeSection === "address" && (
          <>
            <center>
              <h5 className="mb-5">Present Address</h5>
            </center>
            <center>
              <div id="address-area" className="container row px-4">
                <div className="col-12 col-md-6 p-2">
                  <div className="form-group">
                    <label>
                      Address <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <textarea
                      name="address_for_communication"
                      className="form-control"
                      value={preOnboardData.address_for_communication || ""}
                      onChange={handleChange}
                      required
                    ></textarea>
                    {errors.address_for_communication && (
                      <p style={{ color: "red", fontSize: "12px" }}>{errors.address_for_communication}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Area <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="area"
                      className="form-control"
                      value={preOnboardData.area || ""}
                      onChange={handleChange}
                      required
                    />
                    {errors.area && <p style={{ color: "red", fontSize: "12px" }}>{errors.area}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      City <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      value={preOnboardData.city || ""}
                      onChange={handleChange}
                      required
                    />
                    {errors.city && <p style={{ color: "red", fontSize: "12px" }}>{errors.city}</p>}
                  </div>
                </div>
                <div className="col-12 col-md-6 p-2">
                  <div className="form-group">
                    <label>
                      State <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="state"
                      className="form-control"
                      value={preOnboardData.state || ""}
                      onChange={handleChange}
                      required
                    />
                    {errors.state && <p style={{ color: "red", fontSize: "12px" }}>{errors.state}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Country <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="country"
                      className="form-control"
                      value={preOnboardData.country || ""}
                      onChange={handleChange}
                      required
                    />
                    {errors.country && <p style={{ color: "red", fontSize: "12px" }}>{errors.country}</p>}
                  </div>
                  <div className="form-group">
                    <label>
                      Pincode <span style={{ color: "#d32f2f" }}>*</span>
                    </label>
                    <input
                      type="number"
                      name="pincode"
                      className="form-control"
                      value={preOnboardData.pincode || ""}
                      onChange={handleChange}
                      required
                    />
                    {errors.pincode && <p style={{ color: "red", fontSize: "12px" }}>{errors.pincode}</p>}
                  </div>
                </div>
                <div>
                  <label>Permanent Address same as above</label>
                  <input
                    type="checkbox"
                    name="permanent_address"
                    checked={preOnboardData.permanent_address === "yes"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPreOnboardData((prev) => ({
                          ...prev,
                          permanent_address: "yes",
                          permanent_address_for_communication: prev.address_for_communication,
                          permanent_area: prev.area,
                          permanent_city: prev.city,
                          permanent_state: prev.state,
                          permanent_country: prev.country,
                          permanent_pincode: prev.pincode,
                        }));
                      } else {
                        setPreOnboardData((prev) => ({
                          ...prev,
                          permanent_address: "no",
                          permanent_address_for_communication: "",
                          permanent_area: "",
                          permanent_city: "",
                          permanent_state: "",
                          permanent_country: "",
                          permanent_pincode: "",
                        }));
                      }
                    }}
                  />{" "}
                  Yes
                </div>
                <h5>Permanent Address</h5>
                <div id="permanent-address-area" className="container row px-4">
                  <div className="col-12 col-md-6 p-2">
                    <div className="form-group">
                      <label>
                        Address <span style={{ color: "#d32f2f" }}>*</span>
                      </label>
                      <textarea
                        name="permanent_address_for_communication"
                        className="form-control"
                        value={preOnboardData.permanent_address_for_communication || ""}
                        onChange={handleChange}
                        required
                      ></textarea>
                      {errors.permanent_address_for_communication && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          {errors.permanent_address_for_communication}
                        </p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Area <span style={{ color: "#d32f2f" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="permanent_area"
                        className="form-control"
                        value={preOnboardData.permanent_area || ""}
                        onChange={handleChange}
                        required
                      />
                      {errors.permanent_area && <p style={{ color: "red", fontSize: "12px" }}>{errors.permanent_area}</p>}
                    </div>
                    <div className="form-group">
                      <label>
                        City <span style={{ color: "#d32f2f" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="permanent_city"
                        className="form-control"
                        value={preOnboardData.permanent_city || ""}
                        onChange={handleChange}
                        required
                      />
                      {errors.permanent_city && <p style={{ color: "red", fontSize: "12px" }}>{errors.permanent_city}</p>}
                    </div>
                  </div>
                  <div className="col-12 col-md-6 p-2">
                    <div className="form-group">
                      <label>
                        State <span style={{ color: "#d32f2f" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="permanent_state"
                        className="form-control"
                        value={preOnboardData.permanent_state || ""}
                        onChange={handleChange}
                        required
                      />
                      {errors.permanent_state && (
                        <p style={{ color: "red", fontSize: "12px" }}>{errors.permanent_state}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Country <span style={{ color: "#d32f2f" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="permanent_country"
                        className="form-control"
                        value={preOnboardData.permanent_country || ""}
                        onChange={handleChange}
                        required
                      />
                      {errors.permanent_country && (
                        <p style={{ color: "red", fontSize: "12px" }}>{errors.permanent_country}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Pincode <span style={{ color: "#d32f2f" }}>*</span>
                      </label>
                      <input
                        type="number"
                        name="permanent_pincode"
                        className="form-control"
                        value={preOnboardData.permanent_pincode || ""}
                        onChange={handleChange}
                        required
                      />
                      {errors.permanent_pincode && (
                        <p style={{ color: "red", fontSize: "12px" }}>{errors.permanent_pincode}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                <button className="text-light p-2 py-1" onClick={() => setActiveSection("bank")}>
                  Previous
                </button>
                <button className="text-light p-2 py-1" onClick={() => setActiveSection("education")}>
                  Next
                </button>
              </div>
            </center>
          </>
        )}

        {activeSection === "education" && (
          <div style={{ padding: "20px" }}>
            <center>
              <Title level={2}>Academic Details</Title>
            </center>
            <Row gutter={16} justify="center" className="mt-5">
              <Col xs={24} md={8}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Title level={4}>Education History</Title>
                  {addEducation === 1 && (
                    <Button type="dashed" icon={<PlusOutlined />} onClick={() => setAddEducation(addEducation + 1)}>
                      Add
                    </Button>
                  )}
                </div>
                {Array.from({ length: addEducation }, (_, index) => (
                  <Card key={index} className="mb-3" bordered>
                    {addEducation > 1 && (
                      <Space className="mb-3" style={{ justifyContent: "flex-end", width: "100%" }}>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() => setAddEducation(addEducation + 1)}
                        />
                        <Button
                          danger
                          icon={<CloseOutlined />}
                          onClick={() => setAddEducation(addEducation - 1)}
                        />
                      </Space>
                    )}
                    <Form layout="vertical">
                      <Form.Item label="Educational Qualification" >
                        <Input
                          value={preOnboardData.education_history?.[index]?.educational_qualification || ""}
                          onChange={(e) => handleEducationChange(index, "educational_qualification", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Institution Name" >
                        <Input
                          value={preOnboardData.education_history?.[index]?.educational_institution_name || ""}
                          onChange={(e) => handleEducationChange(index, "educational_institution_name", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Degree / Diploma / Course" >
                        <Input
                          value={preOnboardData.education_history?.[index]?.degree_or_diploma || ""}
                          onChange={(e) => handleEducationChange(index, "degree_or_diploma", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="From" >
                        <DatePicker
                          style={{ width: "100%" }}
                          value={
                            preOnboardData.education_history?.[index]?.course_duration_from
                              ? dayjs(preOnboardData.education_history[index].course_duration_from)
                              : null
                          }
                          onChange={(date, dateString) => handleEducationChange(index, "course_duration_from", dateString)}
                        />
                      </Form.Item>
                      <Form.Item label="To" >
                        <DatePicker
                          style={{ width: "100%" }}
                          value={
                            preOnboardData.education_history?.[index]?.course_duration_to
                              ? dayjs(preOnboardData.education_history[index].course_duration_to)
                              : null
                          }
                          onChange={(date, dateString) => handleEducationChange(index, "course_duration_to", dateString)}
                        />
                      </Form.Item>
                      <Form.Item label="Extra curricular Activities">
                        <Input
                          value={preOnboardData.education_history?.[index]?.extra_curricular_activity || ""}
                          onChange={(e) => handleEducationChange(index, "extra_curricular_activity", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="others">
                        <Input
                          value={preOnboardData.education_history?.[index]?.others || ""}
                          onChange={(e) => handleEducationChange(index, "others", e.target.value)}
                        />
                      </Form.Item>
                    </Form>
                  </Card>
                ))}
              </Col>
              <Col xs={24} md={8}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Title level={4}>Career History</Title>
                  {addCareer === 1 && (
                    <Button type="dashed" icon={<PlusOutlined />} onClick={() => setAddCareer(addCareer + 1)}>
                      Add
                    </Button>
                  )}
                </div>
                {Array.from({ length: addCareer }, (_, index) => (
                  <Card key={index} className="mb-3" bordered>
                    {addCareer > 1 && (
                      <Space className="mb-3" style={{ justifyContent: "flex-end", width: "100%" }}>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() => setAddCareer(addCareer + 1)}
                        />
                        <Button
                          danger
                          icon={<CloseOutlined />}
                          onClick={() => setAddCareer(addCareer - 1)}
                        />
                      </Space>
                    )}
                    <Form layout="vertical">
                      <Form.Item label="Company Name" >
                        <Input
                          value={preOnboardData.career_history?.[index]?.organisation || ""}
                          onChange={(e) => handleCareerChange(index, "organisation", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Designation" >
                        <Input
                          value={preOnboardData.career_history?.[index]?.designation || ""}
                          onChange={(e) => handleCareerChange(index, "designation", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="From" >
                        <DatePicker
                          style={{ width: "100%" }}
                          value={
                            preOnboardData.career_history?.[index]?.work_duration_from
                              ? dayjs(preOnboardData.career_history[index].work_duration_from)
                              : null
                          }
                          onChange={(date, dateString) => handleCareerChange(index, "work_duration_from", dateString)}
                        />
                      </Form.Item>
                      <Form.Item label="To" >
                        <DatePicker
                          style={{ width: "100%" }}
                          value={
                            preOnboardData.career_history?.[index]?.work_duration_to
                              ? dayjs(preOnboardData.career_history[index].work_duration_to)
                              : null
                          }
                          onChange={(date, dateString) => handleCareerChange(index, "work_duration_to", dateString)}
                        />
                      </Form.Item>
                      <Form.Item label="Key Responsibilities" >
                        <Input.TextArea
                          rows={2}
                          value={preOnboardData.career_history?.[index]?.keyresponsibilities || ""}
                          onChange={(e) => handleCareerChange(index, "keyresponsibilities", e.target.value)}
                        />
                      </Form.Item>
                    </Form>
                  </Card>
                ))}
              </Col>


              {/* Muted Reference History */}


              {/* <Col xs={24} md={8}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Title level={4}>Reference History</Title>
                  {addReference === 1 && (
                    <Button type="dashed" icon={<PlusOutlined />} onClick={() => setAddReference(addReference + 1)}>
                      Add
                    </Button>
                  )}
                </div>
                {Array.from({ length: addReference }, (_, index) => (
                  <Card key={index} className="mb-3" bordered>
                    {addReference > 1 && (
                      <Space className="mb-3" style={{ justifyContent: "flex-end", width: "100%" }}>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() => setAddReference(addReference + 1)}
                        />
                        <Button
                          danger
                          icon={<CloseOutlined />}
                          onClick={() => setAddReference(addReference - 1)}
                        />
                      </Space>
                    )}
                    <Form layout="vertical">
                      <Form.Item label="Reference Name" >
                        <Input
                          value={preOnboardData.reference_history?.[index]?.referal_name || ""}
                          onChange={(e) => handleReferenceChange(index, "referal_name", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Reference Designation" required>
                        <Input
                          value={preOnboardData.reference_history?.[index]?.referal_desgination || ""}
                          onChange={(e) => handleReferenceChange(index, "referal_desgination", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Reference Mobile" required>
                        <Input
                          value={preOnboardData.reference_history?.[index]?.referal_mobile_number || ""}
                          onChange={(e) => handleReferenceChange(index, "referal_mobile_number", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Reference Email Id" required>
                        <Input
                          value={preOnboardData.reference_history?.[index]?.referal_email_id || ""}
                          onChange={(e) => handleReferenceChange(index, "referal_email_id", e.target.value)}
                        />
                      </Form.Item>
                    </Form>
                  </Card>
                ))}
              </Col> */}
              {/* <Col xs={24} md={8}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Title level={4}>Extra Curricular Activities</Title>
                  {addActivity === 1 && (
                    <Button type="dashed" icon={<PlusOutlined />} onClick={() => setAddActivity(addActivity + 1)}>
                      Add
                    </Button>
                  )}
                </div>
                {Array.from({ length: addActivity }, (_, index) => (
                  <Card key={index} className="mb-3" bordered>
                    {addActivity > 1 && (
                      <Space className="mb-3" style={{ justifyContent: "flex-end", width: "100%" }}>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() => setAddActivity(addActivity + 1)}
                        />
                        <Button
                          danger
                          icon={<CloseOutlined />}
                          onClick={() => setAddActivity(addActivity - 1)}
                        />
                      </Space>
                    )}
                    <Form layout="vertical">
                      <Form.Item label="Activity Name" required>
                        <Input
                          value={preOnboardData.extra_curricular_activity?.[index]?.activity_name || ""}
                          onChange={(e) => handleActivityChange(index, "activity_name", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Description" required>
                        <Input.TextArea
                          rows={2}
                          value={preOnboardData.extra_curricular_activity?.[index]?.activity_description || ""}
                          onChange={(e) => handleActivityChange(index, "activity_description", e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Year / Duration" required>
                        <DatePicker
                          picker="year"
                          style={{ width: "100%" }}
                          value={
                            preOnboardData.extra_curricular_activity?.[index]?.activity_year
                              ? dayjs(preOnboardData.extra_curricular_activity[index].activity_year)
                              : null
                          }
                          onChange={(date, dateString) => handleActivityChange(index, "activity_year", dateString)}
                        />
                      </Form.Item>
                    </Form>
                  </Card>
                ))}
              </Col> */}
            </Row>
            <div className="d-flex justify-content-between w-100 px-3 px-md-5">
              <button className="text-light p-2 py-1" onClick={() => setActiveSection("address")}>
                Previous
              </button>
              <button className="text-light p-2 py-1" onClick={() => setActiveSection("documents")}>
                Next
              </button>
            </div>
          </div>
        )}

        {activeSection === "documents" && (
          <>
            <center>
              <h2 className="mb-3">Onboard Documents</h2>
            </center>
            <div className="container d-flex flex-wrap justify-content-between mt-4 px-2">
              <div className="p-4 col-12 col-md-4">
                <h4 className="mt-2">Personal Details</h4>
                <div className="mb-3">
                  <label className="form-label">Aadhaar Card <span style={{ color: "#d32f2f" }}>*</span></label>
                  <input
                    type="file"
                    className="form-control"
                    name="aadhar_card_copy"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Pan Card <span style={{ color: "#d32f2f" }}>*</span></label>
                  <input
                    type="file"
                    className="form-control"
                    name="pan_card_copy"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Bank Account Details</label>
                  <input
                    type="file"
                    className="form-control"
                    name="bank_account_details"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Covid Certificate</label>
                  <input
                    type="file"
                    className="form-control"
                    name="covid_certificate"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Others (Optional)</label>
                  <input
                    type="file"
                    className="form-control"
                    name="others_1"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Others (Optional)</label>
                  <input
                    type="file"
                    className="form-control"
                    name="others2"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="p-4 col-12 col-md-4">
                <h4 className="mt-2">Educational Documents</h4>
                <div className="mb-3">
                  <label className="form-label">SSLC</label>
                  <input
                    type="file"
                    className="form-control"
                    name="SSLC"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">HSC / Diploma / ITI</label>
                  <input
                    type="file"
                    className="form-control"
                    name="HSC_diploma_ITI"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Degree Certificate</label>
                  <input
                    type="file"
                    className="form-control"
                    name="degree_certificate"
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">PG / PhD</label>
                  <input
                    type="file"
                    className="form-control"
                    name="PG_Phd"
                    onChange={handleChange}
                  />
                </div>
              </div>
              {
                isExperienced && (
                  <div className="p-4 col-12 col-md-4">
                    <h4 className="mt-2">Employment Documents</h4>
                    <div className="mb-3">
                      <label className="form-label">Previous Experience Letter <span style={{ color: "#d32f2f" }}>*</span></label>
                      <input
                        type="file"
                        className="form-control"
                        name="previous_experience_letter"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Last Three Months Payslip <span style={{ color: "#d32f2f" }}>*</span></label>
                      <input
                        type="file"
                        className="form-control"
                        name="last_three_month_payslip"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Last Three Months Account Statement <span style={{ color: "#d32f2f" }}>*</span></label>
                      <input
                        type="file"
                        className="form-control"
                        name="last_three_months_account_statement"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Relieving Letter <span style={{ color: "#d32f2f" }}>*</span></label>
                      <input
                        type="file"
                        className="form-control"
                        name="relieving_letter"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Offer Letter <span style={{ color: "#d32f2f" }}>*</span></label>
                      <input
                        type="file"
                        className="form-control"
                        name="offer_letter"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Appointment Letter</label>
                      <input
                        type="file"
                        className="form-control"
                        name="appointment_letter"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )
              }
            </div>
            <center>
              <div>
                <button className="text-light p-2 py-1" onClick={() => setActiveSection("education")}>
                  Previous
                </button>
              </div>
              <br />
              <button
                onClick={submitFormData}
                disabled={isSubmitting}
                style={{
                  color: "white",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  backgroundColor: "green",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                }}
              >
                {isSubmitting ? "Submitting..." : "Submit Form"}
              </button>
            </center>
          </>
        )}
      </div>
    </>
  );
}